import React from 'react'

type Props = { active: Tab, unsaved?: Tab, onSelect: (tab: Tab) => void }
export type Tab = 'MESSAGE' | 'ON_OFF' | 'GENERAL'
const ConfigTab: React.FC<Props> = ({ active, unsaved, onSelect }) => {
  const items: { tab: Tab, label: string }[] = [
    { tab: 'MESSAGE', label: 'Mensagens Padrões' },
    { tab: 'GENERAL', label: 'Gerais' }
  ]

  return (
    <div className="row config-tab">
      {
        items.map((item, i) => {
          const isUnsaved = item.tab === unsaved
          const isActive = !unsaved || isUnsaved

          return (
            <span
              key={i}
              onClick={() => onSelect(item.tab)}
              className={`tab-option ${active === item.tab ? 'active' : ''}`}
              style={{ opacity: isActive ? 1 : 0.4, pointerEvents: isActive ? 'all' : 'none' }}
            >
              { item.label }
              { isUnsaved && <i className="fa fa-circle" title="Não salvo" style={{ color: 'red' }} /> }
            </span>
          )
        })
      }
    </div>
  )
}

export default ConfigTab
